import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'dateUTC' })
export class DateUTCPipe implements PipeTransform {
  transform(value: string | Date | Date[], format?: string): any {
    if (!value) return '';
    const F = format || 'DD/MM/YY HH:mm';
    if(Array.isArray(value)) {
      return value[0] ? moment(value[0]).format(F) : '';
    } else {
      return value ? moment.utc(value).format(F) : '';
    }
  }
}
